import { Box, Skeleton, Stack } from '@mui/material'
import type { FC } from 'react'

import { COLORS, unit } from '@hcr/ui'

export const BenefitPreviewLoading: FC = () => {
  return (
    <Box marginX={unit(4)} borderBottom={`${unit(0.25)} dashed ${COLORS.vaalea[800]}`}>
      <Stack direction='column' gap={unit(6)} justifyContent='space-between' paddingY={unit(3.5)}>
        <Skeleton width='80%' height={unit(6.5)} variant='rectangular' />
        <Skeleton width='80%' height={unit(6.5)} variant='rectangular' />
      </Stack>
    </Box>
  )
}
